import React from 'react';
import { FileText, CheckCircle, Banknote, ArrowRight } from 'lucide-react';
interface HowItWorksProps {
  language: 'en' | 'es';
}
export function HowItWorks({
  language
}: HowItWorksProps) {
  const content = {
    en: {
      title: 'How It Works',
      subtitle: 'From Application to Funding in Just 24 Hours',
      cta: 'Ready to get started? Apply in 3 minutes.',
      button: 'Start My Application',
      steps: [{
        icon: FileText,
        title: 'Submit Application',
        description: 'Complete our secure online form in minutes. No extensive paperwork or documentation required.'
      }, {
        icon: CheckCircle,
        title: 'Get Approved Same Day',
        description: 'Our experienced team reviews your application and provides fast, professional approval decisions.'
      }, {
        icon: Banknote,
        title: 'Receive Funding in 24 Hours',
        description: 'Once approved, funds are deposited directly into your business account within 24 hours.'
      }]
    },
    es: {
      title: 'Cómo Funciona',
      subtitle: 'De la Solicitud al Financiamiento en Solo 24 Horas',
      cta: '¿Listo para comenzar? Aplique en 3 minutos.',
      button: 'Comenzar Mi Solicitud',
      steps: [{
        icon: FileText,
        title: 'Envíe la Solicitud',
        description: 'Complete nuestro formulario en línea seguro en minutos. Sin papeleo extenso ni documentación requerida.'
      }, {
        icon: CheckCircle,
        title: 'Obtenga Aprobación el Mismo Día',
        description: 'Nuestro equipo experimentado revisa su solicitud y proporciona decisiones de aprobación rápidas y profesionales.'
      }, {
        icon: Banknote,
        title: 'Reciba Fondos en 24 Horas',
        description: 'Una vez aprobado, los fondos se depositan directamente en su cuenta comercial dentro de 24 horas.'
      }]
    }
  };
  const t = content[language];
  const scrollToForm = () => {
    const element = document.getElementById('apply');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="how-it-works" className="w-full py-20 bg-white" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#142B44] mb-4" data-id="element-146">
            {t.title}
          </h2>
          <p className="text-xl text-gray-600" data-id="element-147">{t.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-148">
          {t.steps.map((step, index) => <div key={index} className="relative text-center" data-id="element-149">
              <div className="relative inline-block mb-8" data-id="element-150">
                <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-[#142B44] to-[#2D5D9F] text-white rounded-2xl shadow-xl" data-id="element-151">
                  <step.icon size={40} strokeWidth={2} data-id="element-152" />
                </div>
                <div className="absolute -top-2 -right-2 w-10 h-10 bg-[#142B44] text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg border-4 border-white" data-id="element-153">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-2xl font-bold text-[#142B44] mb-4" data-id="element-154">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-155">
                {step.description}
              </p>
              {index < 2 && <div className="hidden md:block absolute top-12 left-full w-full" data-id="element-156">
                  <div className="h-0.5 bg-gradient-to-r from-[#2D5D9F] via-[#4A90E2] to-transparent animate-pulse" style={{
              width: '100%',
              marginLeft: '-50%'
            }} data-id="element-157"></div>
                </div>}
            </div>)}
        </div>
        <div className="text-center" data-id="element-158">
          <p className="text-xl text-gray-700 font-semibold mb-6" data-id="element-159">{t.cta}</p>
          <button onClick={scrollToForm} className="inline-flex items-center justify-center px-10 py-5 bg-gradient-to-r from-[#142B44] to-[#2D5D9F] text-white font-bold text-lg rounded-xl hover:from-[#2D5D9F] hover:to-[#142B44] transition-all shadow-xl hover:shadow-2xl hover:scale-105 duration-300" data-id="element-160">
            {t.button}
            <ArrowRight className="ml-2" size={20} data-id="element-161" />
          </button>
        </div>
      </div>
    </section>;
}